export const brandingQueries = {
  all: ['branding'] as const,
  brand: (filters: { id: number }) => [...brandingQueries.all, filters],
};
